export default __webpack_public_path__ + "static/media/improve-grades.849ed0fb.svg";